module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_hero-6de44429de68a7472246b55103d3e574.svg";